module.exports = __webpack_public_path__ + "img/avatar_client.eaa78c96.png";